import React, { useContext } from "react";
import PageContext from "../../components/Common/PageContext";
import PrinterSelect from "../../components/Printer/PrinterSelect";
import { FormControlLabel, Grid2 as Grid, Switch, Typography } from "@mui/material";
import { PrinterOutputType } from "../../util/printerEnums";
import { ThemeModeContext } from "@/providers/theme-mode";

export default function Settings() {
	const [pageContext, updatePageContextAsync] = useContext(PageContext);
	const { selectedPrinterId, selectedLabelPrinterId, printers } = pageContext;
	const { mode, toggleMode } = useContext(ThemeModeContext);

	const onPrinterSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
		await updatePageContextAsync({ selectedPrinterId: e.target.value });
	};

	const onLabelPrinterSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
		await updatePageContextAsync({ selectedLabelPrinterId: e.target.value });
	};

	return (
		<>
			<Grid container spacing={2}>
				<Grid size={12}>
					<PrinterSelect
						printers={printers}
						handleChange={onPrinterSelect}
						selectedPrinterId={selectedPrinterId ?? ""}
						title="Default A4 Printer"
						outputType={PrinterOutputType.A4}
					/>
				</Grid>
				<Grid size={12}>
					<PrinterSelect
						printers={printers}
						handleChange={onLabelPrinterSelect}
						selectedPrinterId={selectedLabelPrinterId ?? ""}
						title="Default Label Printer"
						outputType={PrinterOutputType.Zebra}
					/>
				</Grid>
				<Grid size={12}>
					<Typography variant="body1">Display Mode</Typography>
					<FormControlLabel
						control={
							<Switch
								checked={mode === "dark"}
								onChange={toggleMode}
								color="secondary"
								inputProps={{ "aria-label": "dark mode toggle" }}
							/>
						}
						label={mode === "dark" ? "Dark Mode" : "Light Mode"}
					/>
				</Grid>
			</Grid>
		</>
	);
}
